import styled from "@emotion/styled";
import {  Form } from "antd";
import TextArea from "antd/es/input/TextArea";
import { InfoCircleOutlined } from "@ant-design/icons";

import React, { FC } from "react";

interface ProductSGImportantAdviceFormProps {
  is_active: boolean;
}

const ProductSGImportantAdviceForm: FC<ProductSGImportantAdviceFormProps> = ({ is_active }) => {
  return (
 
    <FormWrapper>
      <Form.Item
        label={<span style={{ color: "red"  }}>ข้อแนะนำสำคัญ</span>}
        name="sg_important_advice"
       // rules={[{ required: is_active, message: "กรุณากรอกคำแนะนำสำคัญ" }]}
        tooltip={{
          title: <TooltipContent />,
          icon: <InfoCircleOutlined />,
          color: "#ffffff",
        }}

      >
        <TextArea  placeholder="กรุณากรอกคำแนะนำสำคัญ" showCount maxLength={5000}  rows={10} />
      </Form.Item>
    </FormWrapper>

  );
};

const TooltipContent = () => {
  return (
    <div style={{ width: "100%" }}>
      <h6 style={{ color: "black" }}>ตัวอย่าง “ข้อแนะนำสำคัญ”</h6>
      <p style={{ color: "black" }}>
        1. ควรเก็บไว้ในตู้เย็น อุณหภูมิต่ำกว่า 7 องศาเซลเซียส
      </p>
      <p style={{ color: "black" }}>
        2. สินค้าที่ยังไม่แกะบรรจุภัณฑ์ จะอยู่ได้ในตู้เย็น 3 เดือน
      </p>
    </div>
  );
};


export default ProductSGImportantAdviceForm;

const FormWrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  padding: 20px 20px 2px 20px;
  border-radius: 8px;
  margin-bottom: 10px;
`;
